import Request from 'utils/request';
import config from 'config/Config';
import { hex_md5, Encrypts } from 'utils/md5';
import { decryptParams } from 'utils/constants';

export default class {
  /**
   * 核对订单信息
   */
  static confirmOrder(url, params, ignoreErr = false) {
    return Request({
      url,
      host: params.host || config.HOST_MALL,
      method: 'post_json',
      data: params,
      ignoreErr
    });
  }

  /**
   * 核对订单信息
   */
  static confirmLDOrder(url, params) {
    return Request({
      url,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 检查所属店铺是否可用
   */
  static checkBelongShop(params) {
    return Request({
      url: 'store/code',
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取配送方式
   */
  static getDeliverys(params) {
    return Request({
      url: `biz/tradecore/trade/delivery/query`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取顾客默认收货方式及收货地址
   */
  static getLogistics(params) {
    return Request({
      url: `biz/tradecore/trade/get-by-logistics`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取运费
   */
  static getFreight(data, url) {
    return Request({
      url,
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
  }

  /**
   * 获取下单可用优惠券
   */
  static getCouponList(data) {
    return Request({
      url: `biz/tradecore/trade/query/user-coupon`,
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
  }

  /**
   * 获取下单可用优惠券
   */
  static getFreightCouponList(data) {
    return Request({
      url: `coupon/listFreightCouponByUser`,
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
  }

  /**
   * 创建订单
   */
  static addOrder(url, params) {
    return Request({
      url,
      host: params.host || config.HOST_MALL,
      method: 'post_json',
      data: params,
      ignoreErr: true
    });
  }
  /**
   * 根据分享人卡号获取分享人的 userId
   */

  static getShareUserByCardNo(cardCode) {
    return Request({
      url: 'user/info/getUserId?cardCode=' + cardCode,
      host: config.HOST_MALL
    });
  }

  /**
   * 创建乐道订单
   */
  static addLDOrder(params) {
    return Request({
      url: 'user/largeOrder/submitLargeOrderCardOrder',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 活动下单 - 创建促销活动订单，返回token
   */
  static createPromotionOrder(data) {
    const shareId = localStorage.getItem('shareIdVistor') || void 0;
    return Request({
      url: 'biz/tradecore/trade/promotion/add',
      host: config.HOST_MALL,
      method: 'POST_JSON',
      data: { ...data, shareId }
    });
  }

  /**
   * 控制显示隐藏店铺代收
   */
  static validStoreCollection() {
    return Request({
      url: 'biz/tradecore/trade/validStoreCollection',
      host: config.HOST_MALL
    });
  }

  /**
   * 预售下单 - 创建促销活动订单，返回token
   */
  static createAdvanceSaleOrder(data) {
    const shareId = localStorage.getItem('shareIdVistor') || void 0;
    return Request({
      url: 'biz/tradecore/trade/preSale/add',
      host: config.HOST_MALL,
      method: 'POST_JSON',
      data: { ...data, shareId }
    });
  }

  /**
   * 拼团下单 - 创建促销活动订单，返回token
   */
  static createGroupBuyOrder(data) {
    const shareId = localStorage.getItem('shareIdVistor') || void 0;
    return Request({
      url: 'biz/tradecore/trade/groupSale/add',
      host: config.HOST_MALL,
      method: 'POST_JSON',
      data: { ...data, shareId }
    });
  }

  /**
   * 活动下单 - 查询活动订单下单结果
   */
  static searchActivityOrderResult(token) {
    return Request({
      url: `token/commit/query/result/${token}`,
      host: config.HOST_MALL,
      ignoreErr: true
    });
  }

  /**
   * 查询秒杀拼团预售活动信息
   */
  static getActivityInfo(activityId, itemId) {
    return Request({
      url: `promotion/${activityId}/${itemId}`,
      host: config.HOST_MALL,
      method: 'get'
    });
  }

  /**
   * 查询订单提醒
   */
  static getConfirmTip(params) {
    return Request({
      url: `basic/reminder/queryReminderForFront`,
      host: config.HOST_MALL,
      method: 'get',
      params
    });
  }

  /**
   * 获取协议code
   */
  static getProtocolByItems(data) {
    return Request({
      url: `/biz/tradecore/protocol/getProtocolByItems`,
      host: config.HOST_MALL,
      method: 'POST_JSON',
      data
    });
  }

  /**
   * 获取协议
   */
  static getAgreement(code) {
    return Request({
      url: `basic/contract/query/${code}`,
      host: config.HOST_MALL
    });
  }

  static checkCanPay(data) {
    return Request({
      url: `tradecore/member/checkOpenIdIsSelf`,
      host: config.HOST_MALL,
      method: 'POST_JSON',
      data
    });
  }

  static updateOrderIsShareOrder(tradeNo) {
    return Request({
      url: `tradecore/order/updateShareOrder/${tradeNo}`,
      host: config.HOST_MALL,
      method: 'POST_JSON',
      data: {}
    });
  }

  static queryOrderRemark(params) {
    return Request({
      url: `personal/queryNewSubmitOrderRemark`,
      host: config.HOST_MALL,
      method: 'GET',
      params
    });
  }
  /**
   * 获取顺手买一单商品
   */
  static getEaseBuyItemList(params) {
    return Request({
      url: 'item/query/easebuy/info',
      host: config.HOST_MALL,
      method: 'GET',
      params
    });
  }
  static verifyMemberChangeStatus(params) {
    return Request({
      url: 'user/register/verifyMemberChangeStatus',
      host: config.HOST_MALL,
      method: 'GET',
      ignoreErr: true,
      params
    });
  }
  static queryCouponCreateBv(params) {
    return Request({
      url: 'biz/tradecore/trade/queryCouponCreateBv',
      host: config.HOST_MALL,
      method: 'post_json',
      ignoreErr: true,
      data: params
    });
  }

  /**
   * 上报来源
   */
  static remberOrigin(params) {
    return Request({
      url: 'trade/updateChannelByTradeNo',
      host: config.HOST_MALL,
      method: 'POST',
      params
    });
  }

  /**
   * 致道特定产品信息
   */
  static specialProductCode() {
    return Request({
      url: `${config.HOST_JSON}/app/json/specialAddressProduction.json`,
      method: 'get',
      withCredentials: false,
      ignoreErr: true
    });
  }

  /**
   * 获取顾客默认收货方式及收货地址
   */
  static getSpecialLogistics() {
    return Request({
      url: `${config.HOST_JSON}/app/json/specialLogistics.json`,
      method: 'get',
      withCredentials: false,
      ignoreErr: true
    });
  }

  /**
   * @returns 获取附属赠品
   */
  static getAccessoryGift(data) {
    return Request({
      url: 'biz/tradecore/trade/queryQualifications',
      host: config.HOST_MALL,
      method: 'post_json',
      data,
      ignoreErr: true
    });
  }

  static queryCloudStorageOrderConfig(params) {
    console.log('queryCloudStorageOrderConfigppp', params);

    return Request({
      url: `cloud/share/warehouse/queryCloudStorageOrderConfig?orderType=${params.orderType}&orderAmount=${params.orderAmount}&specialOrder=${params.orderProperty}&type=${params.type}`,
      method: 'get',
      host: config.HOST_MALL
    });
  }

  /**
   * 开店政策配置
   */
  static getStorePolicyConfig(data) {
    return Request({
      url: 'store_policy/config',
      host: config.HOST_STORE,
      method: 'get',
      params: data
    });
  }

  static queryAccumulateCardType(params) {
    return Request({
      url: `trade/queryAccumulateCardType`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  static confirmOrderOptionalInfo(params) {
    return Request({
      url: `/biz/tradecore/trade/confirmOrderOptionalInfo`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 是否包含AI检测产品
   */
  static getHasAIDetectionProduct(params) {
    return Request({
      url: `trade/health/num/config`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 获取享包邮产品
   */
  static getFreeShippingOrderItems(params) {
    return Request({
      url: `item/freeShipping/freeShippingItemDataByCondition`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/CheckOrder/CheckOrderServ.js